export const FETCH_SPECIALTY_REQUEST = "FETCH_SPECIALTY_REQUEST";
